import Button from './Button'
import { Colors } from '../../consts/Colors.js'

export default class ButtonArrow extends Button {
    constructor(scene, x, y, w, h, text, fontSize = "36px", darkMode = false) {
        var params = {
            width: w,
            height: h,
            text: text,
            darkMode: darkMode,
            fontSize: fontSize,
            arrow: 'darkArrow',
            backgroundColor: "",
            textColor: "",
            arrowScale: 0.7
        }

        darkMode ? params.backgroundColor = Colors.Elmt.Blue : params.backgroundColor = Colors.Elmt.White
        darkMode ? params.textColor = Colors.Text.White : params.textColor = Colors.Text.DarkBlue
        darkMode ? params.arrow = 'lightArrow' : 'darkArrow'
        darkMode ? params.arrowScale = 1 : 0.7

        console.log(params)

        super(scene, x, y, params);
    }

    addBody(params) {
        // Ajout fond
        this.back = this.scene.add.rexRoundRectangle(0, 0, params.width, params.height, params.height / 2, params.backgroundColor)
        this.back.setOrigin(0.5)
        this.add(this.back)

        // Ajout text
        this.text = this.scene.add.rexTagText(-20, 0, params.text, {
            fontSize: params.fontSize,
            fontFamily: "Monteserrat",
            align: "center",
            color: params.textColor,
            backgroundColor: 'transparent',
        }).setOrigin(0.5)
        this.add(this.text)

        this.arrow = this.scene.add.image(this.back.width / 2 - 30, 0, params.arrow)
        this.arrow.setScale(params.arrowScale)
        this.add(this.arrow)

        if (this.text.height > params.height) {
            this.back.height = this.text.height + 10
        }

        // Ajout interaction
        this.setSize(this.back.width, this.back.height)
    }

    pointerOut() {
        this.scene.tweens.add({
            targets: this.arrow,
            duration: 100,
            ease: 'Cubic.easeInOut',
            x: this.back.width / 2 - 30,
        })
    }

    pointerOver() {
        this.scene.tweens.add({
            targets: this.arrow,
            duration: 100,
            ease: 'Cubic.easeInOut',
            x: this.back.width / 2 - 25,
        })
    }

    setLocked() {
        this.isLocked = true
        this.setAlpha(0.5)
        this.disableInteractive()
    }

    setUnlocked() {
        this.isLocked = false
        this.setAlpha(1)
        this.setInteractive()
    }

    // -- Modif du text
    setText(txt) {
        this.text.setText(txt)
    }

    setTextColor(color) {
        this.text.color = color
    }

    setTextFont(fontFamily) {
        this.text.fontFamily = fontFamily
    }

    setTextSize(fontSize) {
        this.text.fontSize = fontSize
    }

}